import { Button, Card, Statistic } from "antd";
import { useBookingRetrievalReport } from "./index.hook";
import styles from "../../MasterManagement/index.module.less";
import Loading from "../../common/Loading";
import MultiFunctionDateFilter from "../../common/MultiFunctionDateFilter";

const DataCountDisplay = () => {
  const config = useBookingRetrievalReport();

  return (
    <Card className="gx-card card--height">
      <div className={`gx-title-container`}>
        <span className="card-title-style">Parking Data Counts Report</span>

        <div>
          <div className={styles["filters-container"]}>
            <MultiFunctionDateFilter setFromDate={config.setStartDate} setToDate={config.setEndDate} />
            <Button type="primary" disabled={!config.setStartDate || !config.endDate} className="gx-mb-0 gx-ml-2 gx-mr-0" onClick={config.fetchAllDataCount}>
              Go
            </Button>
          </div>

          <div className={styles["show-date-filter-value"]}>
            <span className="gx-mr-5">
              From Date: &nbsp;<strong>{config?.startDate ?? ""}</strong>
            </span>
            <span>
              To Date: &nbsp;<strong>{config?.endDate ?? ""}</strong>
            </span>
          </div>
        </div>
      </div>

      {config.loading ? (
        <Loading />
      ) : (
        <div className={styles["cards-container"]}>
          <Card className={styles["count-card"]} bordered={false} hoverable>
            <Statistic title="Total Bookings" value={config?.dataCount?.totalBookingCount ?? 0} valueStyle={{ fontSize: "28px", fontWeight: "bold", color: "#1890ff", textAlign: "center" }} prefix={<i className="fas fa-calendar-check"></i>} />
          </Card>

          <Card className={styles["count-card"]} bordered={false} hoverable>
            <Statistic title="Total Storages" value={config?.dataCount?.totalStorageCount ?? 0} valueStyle={{ fontSize: "28px", fontWeight: "bold", color: "orange", textAlign: "center" }} prefix={<i className="fas fa-box-open"></i>} />
          </Card>

          <Card className={styles["count-card"]} bordered={false} hoverable>
            <Statistic title="Total Retrievals" value={config?.dataCount?.totalRetrievalCount ?? 0} valueStyle={{ fontSize: "28px", fontWeight: "bold", color: "#52c41a", textAlign: "center" }} prefix={<i className="fas fa-box-open"></i>} />
          </Card>
        </div>
      )}
    </Card>
  );
};

export default DataCountDisplay;
